import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { OtherCost } from '../model/othercost.model';
import { Tyre } from '../model/tyre.model';
import { Insurance } from '../model/insurance.model';
import { Registration } from '../model/registration.model';
import { Url } from '../model/users.model';
import { Provider } from '../model/providers.model';
import { FleetAssetCompliance } from '../model/fleet_asset_compliance.model';

@Injectable()
export class FleetAssetsService {
  @LocalStorage() url: Url;

  private headers = new Headers({ 'Content-Type': 'application/json' });
  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(public http: HttpClient) {
  }




  getTyres(filter = '', start = '', end = ''): Observable<Tyre[]> {
    if (filter) {
      filter = '/' + filter;
      if (filter == '/range' && start != '' && end != '')
        // if (start == end) {
        //   filter = '/range'
        // }
        // else {
          filter = '/range/' + start + '/' + end;
        // }
    } else filter = '';
    return this.http.get<Tyre[]>(this.url.rest + '/tms/getTyres' + filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getTyresByFleetId(fleetId, filter = '', start = '', end = ''): Observable<Tyre[]> {
    if (filter) {
      filter = '/' + filter;
      if (filter == '/range' && start != '' && end != '')
        // if (start == end) {
        //   filter = '/range'
        // }
        // else {
          filter = '/range/' + start + '/' + end;
        // }
    } else filter = '';
    return this.http.get<Tyre[]>(this.url.rest + '/tms/fleetdetails/getTyresByFleetId/' + fleetId + filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getInsurance(filter = '', start = '', end = ''): Observable<Insurance[]> {
    if (filter) {
      filter = '/' + filter;
      if (filter == '/range' && start != '' && end != '')
        // if (start == end) {
        //   filter = '/range'
        // }
        // else {
          filter = '/range/' + start + '/' + end;
        // }
    } else filter = '';
    return this.http.get<Insurance[]>(this.url.rest + '/tms/getInsurance' + filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getOtherCosts(filter = '', start = '', end = ''): Observable<OtherCost[]> {
    if (filter) {
      filter = '/' + filter;
      if (filter == '/range' && start != '' && end != '')
        // if (start == end) {
        //   filter = '/range'
        // }
        // else {
          filter = '/range/' + start + '/' + end;
        // }
    } else filter = '';
    return this.http.get<OtherCost[]>(this.url.rest + '/tms/getOtherCosts' + filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getRegistrations(filter = '', start = '', end = ''): Observable<Registration[]> {
    if (filter) {
      filter = '/' + filter;
      if (filter == '/range' && start != '' && end != '')
        // if (start == end) {
        //   filter = '/range'
        // }
        // else {
          filter = '/range/' + start + '/' + end;
        // }
    } else filter = '';
    return this.http.get<Registration[]>(this.url.rest + '/tms/getRegistrations' + filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getOtherCostFleetId(fleetId, filter = '', start = '', end = ''): Observable<any[]> {
    if (filter) {
      filter = '/' + filter;
      if (filter == '/range' && start != '' && end != '')
        // if (start == end) {
        //   filter = '/range'
        // }
        // else {
          filter = '/range/' + start + '/' + end;
        // }
    } else filter = '';
    return this.http.get<any[]>(this.url.rest + '/tms/fleetdetails/getOtherCostsByFleetId/' + fleetId + filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }



  deleteFuel(id: number) {
    return this.http.delete(this.url.rest + '/tms/deleteFuel/' + id);
  }

  createTyre(tyre: Tyre): Observable<Tyre> {
    return this.http.post<Tyre>(this.url.rest + '/tms/createTyre', tyre, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  updateTyre(tyre: Tyre): Observable<Tyre> {
    return this.http.post<Tyre>(this.url.rest + '/tms/updateTyre', tyre, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  deleteTyre(id: number) {
    return this.http.delete(this.url.rest + '/tms/deleteTyre/' + id);
  }

  createInsurance(insurance: Insurance): Observable<Insurance> {
    return this.http.post<Insurance>(this.url.rest + '/tms/createInsurance', insurance, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  updateInsurance(insurance: Insurance): Observable<Insurance> {
    return this.http.post<Insurance>(this.url.rest + '/tms/updateInsurance', insurance, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  deleteInsurance(id: number) {
    return this.http.delete(this.url.rest + '/tms/deleteInsurance/' + id);
  }

  createRegistration(registration: Registration): Observable<Registration> {
    return this.http.post<Registration>(this.url.rest + '/tms/createRegistration', registration, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  updateRegistration(registration: Registration): Observable<Registration> {
    return this.http.post<Registration>(this.url.rest + '/tms/updateRegistration', registration, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  createOtherCost(othercost: OtherCost): Observable<OtherCost> {
    return this.http.post<OtherCost>(this.url.rest + '/tms/createOtherCost', othercost, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  createFleetAssetsCert(fleet_asset_compliance: FleetAssetCompliance): Observable<FleetAssetCompliance> {
    return this.http.post<FleetAssetCompliance>(this.url.rest + '/tms/createFleetAssetsCert', fleet_asset_compliance, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getFleetAssetsCert(): Observable<FleetAssetCompliance[]> {
    return this.http.get<FleetAssetCompliance[]>(this.url.rest + '/tms/getFleetAssetsCert', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  updateCompliance(fleet_asset_compliance:FleetAssetCompliance): Observable<FleetAssetCompliance> {
    return this.http.post<FleetAssetCompliance>(this.url.rest  + '/tms/updateCompliance', fleet_asset_compliance, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  updateOtherCost(othercost: OtherCost): Observable<OtherCost> {
    return this.http.post<OtherCost>(this.url.rest + '/tms/updateOtherCost', othercost, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  deleteOtherCost(id: number) {
    return this.http.delete(this.url.rest + '/tms/deleteOtherCost/' + id);
  }

  deleteRegistration(id: number) {
    return this.http.delete(this.url.rest + '/tms/deleteRegistration/' + id);
  }

  deleteCompliance(id:number) {
    return this.http.delete(this.url.rest + '/tms/deleteCompliance/' + id);
  }

  removeModules(id:number) {
    return this.http.delete(this.url.rest + '/tms/removeModules/' + id);
  }

  createFile(image_file: any): Observable<File> {
    return this.http.post<File>(this.url.rest + '/tms/upload/file', image_file, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  deleteFile(fileName: string) {
    return this.http.delete(this.url.rest + '/tms/delete/file' + fileName)

  }

  getFleetAssetsMisc(): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/getFleetAssetsMisc', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getFuelSummaryByFleetId(fleet_id): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/fleetdetails/getFuelSummaryByFleetId/' + fleet_id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getTyreSummaryByFleetId(fleet_id): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/fleetdetails/getTyreSummaryByFleetId/' + fleet_id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getOtherCostSummaryByFleetId(fleet_id): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/fleetdetails/getOtherCostSummaryByFleetId/' + fleet_id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getProvidersTyre(): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/getProvidersTyre', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  };

  getProvidersInsurance(): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/getProvidersInsurance', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  };

  getProvidersFuel(): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/getProvidersFuel', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  };

  getProvidersRepairsServices(): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/getProvidersRepairsServices', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  };

  getProvidersRegistration(): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/getProvidersRegistration', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  };

  getProvidersOthers(): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest + '/tms/getProvidersOthers', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  };

  getProviders(): Observable<Provider[]> {
    return this.http
      .get<Provider[]>(`${this.url.rest}/tms/providers`)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

}